import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CommandBarButton } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import classNames from 'classnames';
import { useBrandsData } from './brands-data';

const getStyles = (_components, { palette }) => ({
  RequestBrandButton: {
    height: 32,
    color: palette.themePrimary,

    '&.is-disabled': {
      color: palette.neutralTertiaryAlt,
    },
  },
});

export const RequestBrandButton = ({
  onClick,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  const {
    isSelectedOptionsLimitReached,
  } = useBrandsData();

  return (
    <CommandBarButton
      className={classNames(classes.RequestBrandButton, 'request-brand-button')}
      text={i18n.getString(_TL_('Request a brand'))}
      iconProps={{ iconName: 'Add' }}
      onClick={onClick}
      disabled={isSelectedOptionsLimitReached}
    />
  );
};

RequestBrandButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
